import MiPassword from './password';
import { install } from '../../utils/install';
export default install(MiPassword);
